import React, { useContext } from 'react';
import { CircleLoader, NumberFormat } from 'components';
import { countryTaxRateContext } from '../CountryTaxRateContext';
import { Table, TableBody, TableCell, TableFooter, TableHead, TableRow, Typography } from '@mui/material';


let Results = () => {
    let service = useContext(countryTaxRateContext);

    return (
        <div>
            {service.isLoading && <CircleLoader />}
            {service.isLoading === false &&
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Country code</TableCell>
                            <TableCell>Country name</TableCell>
                            <TableCell>Tax rate</TableCell>
                            <TableCell>Tax code</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {service.countriesTaxRate.map((countryTaxRate, index) =>
                            <TableRow hover key={index}>
                                <TableCell>{countryTaxRate.countryCode}</TableCell>
                                <TableCell>{countryTaxRate.countryName}</TableCell>
                                <TableCell>
                                    <NumberFormat amount={countryTaxRate.taxRateEcomB2C} suffix="%" />
                                </TableCell>
                                <TableCell>{countryTaxRate.taxCodeEcomB2C}</TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                    {service.isLoading === false && service.countriesTaxRate.length === 0 &&
                        <TableFooter>
                            <TableRow>
                                <TableCell colSpan={3}>
                                    <Typography variant="subtitle2">No results found</Typography>
                                </TableCell>
                            </TableRow>
                        </TableFooter>
                    }
                </Table>
            }
        </div>
    );
}

export default Results;